<script lang="ts">
import formFieldsInit from '../../utils/formFieldsInit.vue'
import FormLabel from './label.vue'

export default {
    name: 'TextareaField',
    components: { FormLabel },
    extends: formFieldsInit,
    props: {
        keepSpacesAndLineBreaks: { type: Boolean, required: false, default: true },
        rows: { type: Number, required: false, default: 3 },
        placeholder: { type: String, required: false, default: undefined }
    },
    emits: ['updateData'],
}
</script>

<template>
    <FormLabel v-if="(data || injectedData || formService?.data) && (value !== undefined || rule)">
        <v-textarea
            v-if="rule"
            :id="customId ?? dataKey"
            :name="customId ?? dataKey"
            class="custom-input"
            :type="type || 'text'"
            density="compact"
            :value="value"
            variant="outlined"
            :suffix="suffix"
            :rows
            :disabled="disabled"
            persistent-hint
            :hint="getInfo()"
            :error-messages="getErrors()"
            :placeholder
            @input="(validation && validation.$touch()) || injectedValidation?.$touch()"
            @blur="validation && validation.$touch()"

            @update:model-value="$emit('updateData', $event); updateData($event)"
        />

        <div v-else>
            <div
                v-if="value"
                class="detail-value"
                :class="{ 'detail-value--keep-spaces': keepSpacesAndLineBreaks }"
                v-text="value"
            />
            <div v-else>
                <small class="font-italic text-disabled">-</small>
            </div>
        </div>
    </FormLabel>
</template>

<style scoped>
.detail-value {
    /* A long word — a pasted URL — has to wrap instead of overflowing its column. */
    overflow-wrap: break-word;
}

/* Line breaks and consecutive spaces are kept by the layout rather than by markup :
   `pre-wrap` preserves them and, unlike the `<br/>` + `&nbsp;` it replaces, still lets
   the text wrap at every space. */
.detail-value--keep-spaces {
    white-space: pre-wrap;
}
</style>
